import updateUserInfo from '../api/updateUserInfo';
import * as userStore from '../stores/userStore';
import handleGenericErrors from './handleGenericErrors';

export function hasWizardBeenStarted(
  startedKey: string,
  wizardsStarted: readonly string[] | undefined,
): boolean {
  return wizardsStarted?.includes(startedKey) ?? false;
}

export async function markWizardStarted(startedKey: string): Promise<void> {
  const wizardsStarted = userStore.state.userInfo.wizardsStarted ?? [];

  if (hasWizardBeenStarted(startedKey, wizardsStarted)) {
    return;
  }

  const { data, error } = await updateUserInfo({
    wizardsStarted: [...wizardsStarted, startedKey],
  });

  if (error) {
    await handleGenericErrors(error);
    return;
  }

  if (data?.userInfo) {
    userStore.state.userInfo = data.userInfo;
  }
}
